import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import Noaccess from '@/components/auth/Noaccess'

import DocumentList from '@/components/integration-staging/DocumentList'
import UpdateDocumentData from '@/components/integration-staging/UpdateDocumentData'
import InvoiceList from '@/components/manage-documents/InvoiceList'
import HistoricalData from '@/components/historical-data/AddHistoricalData'
import CrossReferenceList from '@/components/integration-staging/CrossReferenceList'
import UpdateCrossReferenceData from '@/components/integration-staging/UpdateCrossReferenceData'

import DocumentHistoryList from '@/components/integration-history/DocumentHistoryList'
import LocationList from '@/components/integration-staging/Location/LocationList.vue'
import DocumentDeleteList from '@/components/integration-staging/DocumentDeleteList.vue'

import UserList from '@/components/manage-user/UserList'
import AddUser from '@/components/manage-user/AddUser'
import UserRoleMapping from '@/components/manage-user/UserModuleMapping'

import ErrorList from '@/components/integration-errors/IntegrationErrorList.vue'
import UpdateErrorDetails from '@/components/integration-errors/updateErrorDetails.vue'

import IPOMemberVendorConfigList from '@/components/ipo/MembervendorConfigurationList.vue'
import ipoMemberModal from '@/components/ipo/CreatememberVendorConfiguration.vue'
import IpoMemberUpdate from '@/components/ipo/UpdateMemberConfiguration.vue'
import IpoTest from '@/components/ipo/IPOTest.vue'

import PartnerList from '@/components/manage-cxml/PartnerList.vue'
import PartnerUpdate from '@/components/manage-cxml/UpdatePartner.vue'

import TrackingList from '@/components/integration-tracking/TrackingList.vue'
import TrackingUpdate from '@/components/integration-tracking/UpdateTracking.vue'

import AgreementList from '@/components/biztlak-partner-management/AgreementList.vue'

import CrossReferenceTrace from '@/components/integration-staging/CrossReferenceTrace.vue'


import Vuetable from '@/components/vuetable-2/Vuetable'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropDown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'
import VuetablePaginationMixin from '@/components/vuetable-2/VuetablePaginationMixin.vue'
import VuetablePaginationInfoMixin from '@/components/vuetable-2/VuetablePaginationInfoMixin.vue'
import Promise from 'promise-polyfill'


if (!window.Promise) {
	window.Promise = Promise
}

function install(Vue){
  Vue.component("vuetable", Vuetable);
  Vue.component("vuetable-pagination", VuetablePagination);
  Vue.component("vuetable-pagination-dropdown", VuetablePaginationDropDown);
  Vue.component("vuetable-pagination-info", VuetablePaginationInfo);
}
export {
  Vuetable,
  VuetablePagination,
  VuetablePaginationDropDown,
  VuetablePaginationInfo,
  VuetablePaginationMixin,
  VuetablePaginationInfoMixin,
  install
};

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
       path: '/', 
       name: 'Login', 
       component: Login 
    },
    { 
      path: '/documentlist', 
      name: 'DocumentList', 
      component: DocumentList
    },
    { 
      path: '/UpdateDocumentData', 
      name: 'UpdateDocumentData', 
      component: UpdateDocumentData
    },
    { 
      path: '/Invoicelist', 
      name: 'InvoiceList', 
      component: InvoiceList
    },
    { 
      path: '/HistoricalData', 
      name: 'HistoricalData', 
      component: HistoricalData
    },
    { 
      path: '/CrossReferenceList', 
      name: 'CrossReferenceList', 
      component: CrossReferenceList
    },
    { 
      path: '/UpdateCrossReferenceData', 
      name: 'UpdateCrossReferenceData', 
      component: UpdateCrossReferenceData
    },
    { 
      path: '/DocumentHistoryList', 
      name: 'DocumentHistoryList', 
      component: DocumentHistoryList
    },
    { 
      path: '/LocationList', 
      name: 'LocationList', 
      component: LocationList
    },
    { 
      path: '/DocumentDeleteList', 
      name: 'DocumentDeleteList', 
      component: DocumentDeleteList
    },
    { 
      path: '/Noaccess', 
      name: 'Noaccess', 
      component: Noaccess
    },
    { 
      path: '/UserList', 
      name: 'UserList', 
      component: UserList
    },
    { 
      path: '/AddUser', 
      name: 'AddUser', 
      component: AddUser
    },
    { 
      path: '/UserRoleMapping', 
      name: 'UserRoleMapping', 
      component: UserRoleMapping
    },
    { 
      path: '/ErrorList', 
      name: 'ErrorList', 
      component: ErrorList
    },
    { 
      path: '/UpdateErrorDetails', 
      name: 'UpdateErrorDetails', 
      component: UpdateErrorDetails
    },
    { 
      path: '/IPOMemberVendorConfigList', 
      name: 'IPOMemberVendorConfigList', 
      component: IPOMemberVendorConfigList
    },
    { 
      path: '/ipoMemberModal', 
      name: 'ipoMemberModal', 
      component: ipoMemberModal
    },
    { 
      path: '/IpoMemberUpdate', 
      name: 'IpoMemberUpdate', 
      component: IpoMemberUpdate
    },
    { 
      path: '/IpoTest', 
      name: 'IpoTest', 
      component: IpoTest
    },
    { 
      path: '/PartnerList', 
      name: 'PartnerList', 
      component: PartnerList
    },
    { 
      path: '/PartnerUpdate', 
      name: 'PartnerUpdate', 
      component: PartnerUpdate
    },
     { 
         path: '/TrackingList', 
         name: 'TrackingList', 
         component: TrackingList
     },
    { 
        path: '/TrackingUpdate', 
        name: 'TrackingUpdate', 
        component: TrackingUpdate
    },
    { 
      path: '/AgreementList', 
      name: 'AgreementList', 
      component: AgreementList
    },
    { 
      path: '/CrossReferenceTrace', 
      name: 'CrossReferenceTrace', 
      component: CrossReferenceTrace
    }
    
  ]
})


/*
router.beforeEach((to, from, next) => {
  alert(to.path);
   if (sessionStorage.getItem('id_token') != null || to.path !== '/login') {
     next()
  } else {
    next('/login')
  }
})
*/




export default router


// WEBPACK FOOTER //
// ./src/router/index.js